var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoDsactiverFiltres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3342",
    "data-name": "Groupe 3342",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.198,
    height: 14.291,
    viewBox: "0 0 14.198 14.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 14.198,
    height: 14.291,
    fill: "#11264c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3342-2",
    "data-name": "Groupe 3342",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1179",
    "data-name": "Trac\\xE9 1179",
    d: "M141.817,0a3.6,3.6,0,1,0,3.6,3.6,3.6,3.6,0,0,0-3.6-3.6m1.418,4.407a.473.473,0,1,1-.67.67l-.777-.777-.777.777a.473.473,0,1,1-.67-.67l.777-.777-.777-.777a.474.474,0,0,1,.67-.67l.777.777.777-.777a.474.474,0,0,1,.67.67l-.777.777Z",
    transform: "translate(-131.22 0)",
    fill: "#11264c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1180",
    "data-name": "Trac\\xE9 1180",
    d: "M6.1,58.793a4.554,4.554,0,0,1,.044-.629H.366a.365.365,0,0,0-.3.576l3.691,5.233a.365.365,0,0,1,.067.211v4.962a.365.365,0,0,0,.554.313L6.7,68.06a.365.365,0,0,0,.177-.313V64.184a.365.365,0,0,1,.068-.212l1.065-1.5a4.508,4.508,0,0,1-1.9-3.684",
    transform: "translate(0 -55.22)",
    fill: "#11264c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDsactiverFiltres);
export default __webpack_public_path__ + "static/media/picto-désactiver-filtres.8ee6010c62bdda6b07e3d1f8a00d2291.svg";
export { ForwardRef as ReactComponent };